import React, { useState } from 'react';

/**
 * Optimized image component with placeholder and lazy loading
 * Shows skeleton/blur while loading, handles errors gracefully
 */
const ImageWithPlaceholder = ({ 
  src, 
  alt, 
  className = '', 
  fallbackSrc = '/images/defaultBook.png',
  skeletonClassName = ''
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className="relative overflow-hidden">
      {/* Skeleton placeholder - shows while loading */}
      {!loaded && !error && (
        <div 
          className={`absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse ${skeletonClassName || className}`}
          style={{ animation: 'pulse 1.5s ease-in-out infinite' }}
        />
      )}
      
      {/* Actual image */}
      <img
        src={error ? fallbackSrc : src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`${className} transition-opacity duration-300 ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setError(true);
          setLoaded(true); // Show fallback immediately
        }}
      />
    </div>
  );
};

export default ImageWithPlaceholder;
